import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';

import useToast from '../../../hooks/useToast';
import LoaderContext from '../../../context/LoaderProvider';
import { deletePositionLine } from '../../../services/workReport';

const DeletePositionLineModal = ({
  positionLineId,
  position,
  line,
  showDeleteModal,
  setShowDeleteModal,
  setRefreshFetch
}) => {
  const { setNewToast } = useToast();

  const { setLoader } = useContext(LoaderContext);

  const deleteLineWorkReport = async () => {
    setLoader(true);
    try {
      const res = await deletePositionLine(positionLineId);

      setRefreshFetch((refresh) => !refresh);
      setLoader(false);
      setNewToast({
        type: 'SUCCESS',
        message: res.mensaje
      });
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={() => setShowDeleteModal(false)}
      primaryAction={() => {
        deleteLineWorkReport();
        setShowDeleteModal(false);
      }}
      primaryActionLabel="Aceptar"
      secondaryAction={() => setShowDeleteModal(false)}
      secondaryActionLabel="Salir"
      show={showDeleteModal}
      size="md"
      title="Eliminar"
      variantHeader="danger"
    >
      <div className="modal_body_error">
        ¿Querés eliminar la <strong>{`"Línea ${line}`}</strong>{' '}
        <strong>{`Posición ${position}"`}</strong>?
      </div>
    </ModalGeneric>
  );
};

DeletePositionLineModal.propTypes = {
  line: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  positionLineId: PropTypes.number.isRequired,
  setShowDeleteModal: PropTypes.func.isRequired,
  showDeleteModal: PropTypes.bool.isRequired,
  setRefreshFetch: PropTypes.func.isRequired
};

export default DeletePositionLineModal;
